export const QUIZ_QUESTIONS = [
  {
    id: 1,
    question: "What is the BIGGEST cat in the world?",
    options: ["Lion", "Tiger", "Cheetah", "Leopard"],
    answerIndex: 1,
    fact: "Tigers are even bigger than lions!",
  },
  {
    id: 2,
    question: "Which type of tiger lives in the snow?",
    options: ["Bengal Tiger", "Sumatran Tiger", "Siberian Tiger", "Malayan Tiger"],
    answerIndex: 2,
    fact: "Siberian tigers have thick fur to stay warm in Russia.",
  },
  {
    id: 3,
    question: "What do tigers eat?",
    options: ["Only fruits", "Only grass", "Meat (they are carnivores)", "Fish only"],
    answerIndex: 2,
    fact: "Tigers are carnivores — they eat deer, boar, and other animals.",
  },
  {
    id: 4,
    question: "About how many wild tigers are left in the world today?",
    options: ["Around 100", "Around 4,500", "Around 50,000", "Around 1 million"],
    answerIndex: 1,
    fact: "Sadly only ~4,500 — that's why we MUST protect them.",
  },
  {
    id: 5,
    question: "What is special about every tiger's stripes?",
    options: [
      "They glow in the dark",
      "Every tiger has a UNIQUE pattern (like fingerprints)",
      "They are painted on",
      "All tigers have the same stripes",
    ],
    answerIndex: 1,
    fact: "Yes! No two tigers have the exact same stripes.",
  },
];
